var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableHeadRow, TableRow, } from "../table/simple";
import { DishOptionSetList } from "../elements/dish.option-set-list";
import { DishOpenItemModifierList } from "../elements/dish.open-item-modifier-list";
import { DishIngredientsList } from "../elements/dish.ingredients-list";
import { DishComboChoiceList } from "../elements/dish.combo-list";
import Big from "big.js";
import { SortType } from '@lib/common';
import styled from "styled-components";
const EllipsisWrapper = styled.p `
    white-space: wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 285px;
`;
let OrderItemsClass = class OrderItemsClass extends React.Component {
    render() {
        const { t } = this.props;
        const { items, itemContent, isPrinting } = this.props;
        const details = this.props.renderDetails || {
            enabled: true,
            prices: true,
            option_prices: true,
            combo_choice_names: true,
            disable_print_name: true,
            sort_type: SortType.ByCart.toString()
        };
        if (!details.enabled) {
            return null;
        }
        return (React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableHeadRow, null,
                    React.createElement(TableHeadCell, { className: "cart-items-head-qty", style: { width: "40px" } }, t("order.receipt.dishes.headings.quantity")),
                    React.createElement(TableHeadCell, { className: "text-left" }, t("order.receipt.dishes.headings.item")),
                    details.prices && React.createElement(TableHeadCell, { className: "cart-items-head-price", style: { width: "80px" } }, t("order.receipt.dishes.headings.price")))),
            React.createElement(TableBody, null, items.map((dish, i) => (React.createElement(TableRow, { key: i },
                React.createElement(TableCell, null,
                    React.createElement("p", null, dish.qty)),
                React.createElement(TableCell, { className: "text-left" },
                    React.createElement(EllipsisWrapper, null, (details.disable_print_name) ?
                        (dish.display_name || dish.name)
                        : (dish.print_name || dish.display_name || dish.name)),
                    ((details.subtitle !== false) && dish.subtitle) && React.createElement("p", { className: "small lh14" }, dish.subtitle),
                    dish.type !== "combo" && (React.createElement("div", null,
                        (dish.option_sets || []).length > 0 && (React.createElement("div", { className: "m-t-1" },
                            React.createElement(DishOptionSetList, { option_sets: dish.option_sets, renderDetails: details, isPrinting: isPrinting, dishQty: dish.qty }))),
                        (dish.ingredients || []).length > 0 && (React.createElement("div", { className: "m-t-1" },
                            React.createElement(DishIngredientsList, { ingredients: dish.ingredients }))))),
                    dish.type === "combo" && (React.createElement("div", { className: "m-t-1" },
                        React.createElement(DishComboChoiceList, { choices: dish.choices, renderDetails: details, dishQty: dish.qty }))),
                    dish.type === "open_item" && dish.open_item_modifiers && dish.open_item_modifiers.length > 0 && (React.createElement("div", { className: "m-t-1" },
                        React.createElement(DishOpenItemModifierList, { open_item_modifiers: dish.open_item_modifiers, renderDetails: details, isPrinting: isPrinting }))),
                    dish.notes && React.createElement("p", { className: "m-t-1 small" },
                        t("order.receipt.dishes.notes"),
                        ": ",
                        dish.notes),
                    itemContent && itemContent(dish, i)),
                details.prices && (React.createElement(TableCell, null,
                    (typeof dish.discount === "number" && dish.discount > 0) && (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "small" },
                            React.createElement("s", null, t("currency", { value: dish.price }))),
                        React.createElement("p", null, t("currency", { value: Big(dish.price).minus(dish.discount).toFixed(2) })))),
                    (typeof dish.discount === "undefined") && (React.createElement("p", null, dish.price !== 0 ? t("currency", { value: dish.price }) : "Free"))))))))));
    }
};
OrderItemsClass = __decorate([
    observer
], OrderItemsClass);
export const OrderItems = withTranslation()(OrderItemsClass);
//# sourceMappingURL=order-items.js.map